import { useContext } from 'react';
import PageContext from './PageContext';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import pencilIcon from '../../svgs/pencil-icon.svg';
import PageTooltip from './PageTooltip';
import isNullOrUndefined from '../functions/isNullOrUndefined'; 
import { TableCell } from '@mui/material';
 
const UserInventoryRow = ({ row, count, tableHeader }) =>{
    const {
        setEditUserModal, 
        setEditUserRow,
        roleFilterData
    } = useContext(PageContext);

    let showElements = (el) => {
        if (el['columnname'] === 'custom:Active'){
            if (row[el['columnname']] == 1){
                return <img src={greenCircleIcon} class='data-table-icon-left'/> 
            }
            else{
                return <img src={redCircleIcon} class='data-table-icon-left'/>  
            }
        }
        else if (el['columnname'] == 'last_updated') {
            let date = row[el['columnname']].split('T')[0].split('-');
            return <>{date[1].concat('-', date[2], '-', date[0])}</>
        }
        else if (el['columnname'] === 'custom:Role') {
            if (!isNullOrUndefined(roleFilterData[row[el['columnname']]])) {
                return <>{roleFilterData[row[el['columnname']]]}</>
            }
            else {
                return <>{row[el['columnname']]}</>
            }
        }
        else if (el['columnname'] === 'blank') {
            return <PageTooltip title='edit'>
                <img src={pencilIcon} className='data-table-icon' onClick={(e)=>onEditClick(e)}/>
            </PageTooltip>
        }
        else {
            return <>{row[el['columnname']]}</>
        }
    }
    
    const onEditClick = () => {
        setEditUserModal(editUserModal => editUserModal = true);
        setEditUserRow(editUserRow => editUserRow = row);
    }

    return(
        <>
            {tableHeader.map(el => 
                <TableCell>{showElements(el)}</TableCell>
            )}
        </>
    );
}

export default UserInventoryRow; 